import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-Increase",
  "use": "icon-icon-Increase-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-Increase\"><path d=\"M733.6 478.4L518.4 227.2c-4.8-4.8-10.4-4.8-15.2 0L292.8 478.4c-4.8 4.8 0 10.4 4.8 10.4h123.2v302.4c0 4.8 0 10.4 4.8 10.4h164c4.8 0 10.4-4.8 10.4-10.4V488h123.2c10.4 0 10.4-4.8 10.4-9.6z\" p-id=\"11083\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol